import { posthog } from 'posthog-js'
import { SESSION_FLAG_KEY } from './constants'

interface ExpireActiveSessionOptions {
  clearClientState?: () => void
}

export function expireActiveSession({ clearClientState }: ExpireActiveSessionOptions = {}): boolean {
  if (globalThis.window === undefined)
    return false
  if (localStorage.getItem(SESSION_FLAG_KEY) !== 'true')
    return false

  localStorage.removeItem(SESSION_FLAG_KEY)
  clearClientState?.()
  posthog.reset()
  globalThis.location.assign('/login')
  return true
}
